import { createLog } from "@app/debug";
import { useRef } from "react";
const log = createLog("tuna");

export function tunaEvent(event: string, data: any = null) {
  log(event, data);

  if (import.meta.env.VITE_TUNA_ENABLED === "true") {
    const w = window as any;
    if (typeof w === "undefined") return;
    if (!w.aptible) return;
    if (typeof w.aptible.event !== "function") return;
    w.aptible.event(event, data);
  }
}

export function tunaIdentify(email: string, userId?: string) {
  log("identify", email);

  if (import.meta.env.VITE_TUNA_ENABLED === "true") {
    const w = window as any;
    if (typeof w === "undefined") return;
    if (!w.aptible) return;
    if (typeof w.aptible.identify !== "function") return;
    w.aptible.identify(email, userId);
  }
}

/**
 * A hook that returns the props needed to fire a Tuna event on hover.
 *
 * After hovering for minHoverDurationMs, fires tunaEvent with the given name and payload.
 *
 * @param minHoverDurationMs - Minimum hover duration before firing the event. Defaults to 250ms.
 * @returns A object with onMouseEnter and onMouseLeave props for tracking mouse hover event.
 */
export const useTunaHoverEvent = (
  eventName: string,
  payload: string,
  minHoverDurationMs = 250,
) => {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  return {
    onMouseEnter: () => {
      timer.current = setTimeout(
        () => tunaEvent(eventName, payload),
        minHoverDurationMs,
      );
    },
    onMouseLeave: () => clearTimeout(timer.current),
  };
};
